/* eslint-disable import/prefer-default-export */

/**
 * Format service response
 * @param response
 */
export const formatResponse = (response) => {
  if (!response.status || response.status < 200 || response.status >= 300) {
    // Check terminal window for what endpoint failed
    const error: Error & { data?: any } = new Error(response?.error);

    error.data = response;
    throw error;
  }

  return response?.data?.data || response?.data || null;
};
